import axios from '@fuse/utils/axios';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup'
import { Button, Icon, IconButton, makeStyles, Modal, TextField } from '@material-ui/core';
import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';
import { generateRandomNumberString } from '@fuse/utils/stringOperations'

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

function QuickAddSrviceLevelAggrement(props) {

    const classes = useStyles()
    const dispatch = useDispatch()
    const toast = useToast(dispatch)

    const schema = yup.object({
       
    })

    const defaultValues = {
        service_level_aggrement: ''
    }

    const { 
        control, 
        formState:{errors}, 
        handleSubmit, 
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    function manageFormData(formData){
        // console.log('manageData: ',formData);
        const payload = {
			entity_external_platform_id: generateRandomNumberString(),
			sla: formData.service_level_aggrement.trim()
		}

		axios.post('/service-level-agreement/add', payload).then(res => {
			if(res.status === 201){
				toast.error(res.data.message)
                return
			}
            close(res.data.data)
            toast.success('Service Level Agreement added successfully')

		}).catch(err => {
            console.log('error: ',err);
			// toast.error('Something went wrong!')
		})

    }

    function formErrorData(error){
        console.log('formErrorData: ',error);
    }

    function close(new_service_level_aggrement=null){
        reset(defaultValues)
        props.handleCloseDialog(new_service_level_aggrement)
    }

    return (
        <Modal
            open={props.open}
            // onClose={()=>close()}
            className={classes.modal}
        >
            <div style={{width:700, backgroundColor: 'white', borderRadius:9,display:'flex', flexDirection:'column', padding:'20px'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                    <h1>Create Service Level Agreement</h1>
                    <IconButton onClick={()=>close()}>
                        <Icon>close</Icon>
                    </IconButton>
                </div>

                <form onSubmit={handleSubmit(manageFormData,formErrorData)}>
                    <div style={{backgroundColor: 'rgb(239 239 239)', borderRadius:9, padding: '15px'}}>
                        
                        <Controller
                            name="service_level_aggrement"
                            className="mb-16"
                            defaultValue={''}
                            control={control}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        variant='outlined'
                                        label='Service Level Agreement'
                                        required
                                        style={{ marginBottom: '10px', width: '100%',background: 'white' }}
                                    />
                                </>
                            )}
                        />
                    </div>
                    <div style={{display:'flex',gap:'20px',paddingTop:'20px'}}>
                        <Button
                            variant='contained' color='primary' size='small' style={{ borderRadius: '4px' }}
                            type='submit'
                        >Add</Button>
                        <Button 
                            variant='outlined' color='primary' size='small' style={{ borderRadius: '4px' }}
                            onClick={()=>close()}
                        >Cancel</Button>
                    </div>
                </form>
            </div>

        </Modal>
    )
}

export default QuickAddSrviceLevelAggrement
